import { Button, Checkbox, Container, FormControl, FormErrorMessage, FormLabel, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Textarea } from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import { FC, useEffect, useState } from "react";
import LogosNotification from "utils/notification-utils";
import ConfirmDialog from "../../../../components/confirm-dialog";
import ProgramService from "../../../../services/programs/program-service";

interface AddLessonGroupDialogProps {
    program: any,
    lessonGroupId:string,
    lesson: any,
    resource:any,
    onClose: any
};

const RemoveLessonResourceDialog: FC<AddLessonGroupDialogProps> = ({ program, lessonGroupId, lesson, onClose, resource }) => {
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);

    useEffect(() => {
    }, []);

    const handleFormSubmit = (values: any) => {
        setIsSubmiting(true);
        ProgramService.DeleteLessonResource(program.id, lessonGroupId, lesson.id, resource.id).then((res: any) => {
            LogosNotification.Success("Resource berhasil dihapuskan.");
            window.location.reload();
        }).finally(() => {
            setIsSubmiting(false);
        })
    };

    return (
        <ConfirmDialog
            title={'Hapus Resource'}
            message={`Apakah Anda yakin untuk Resource Lesson ${resource.resourceName}?`}
            colorScheme={'red'}
            buttonLabel={'Hapuskan'}
            onSubmit={handleFormSubmit}
            onClose={onClose}
            isLoading={isSubmiting}
        />
    );
};

export default RemoveLessonResourceDialog;
